import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DateTime } from 'luxon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRippleModule } from '@angular/material/core';
import { RouterLink } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';

@Component({
    selector: 'vex-quickpanel',
    templateUrl: './quickpanel.component.html',
    styleUrls: ['./quickpanel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatDividerModule,
        MatListModule,
        RouterLink,
        MatRippleModule,
        MatProgressBarModule
    ]
})
export class QuickpanelComponent {
  readonly date = DateTime.local().toFormat('DD');
  readonly dayName = DateTime.local().toFormat('EEEE');
}
